import greenFist from "@/assets/punch-fist-green.png.asset.json";
import purpleFist from "@/assets/punch-fist-purple.png.asset.json";

interface PunchFistProps {
  variant: "green" | "purple";
  className?: string;
  alt?: string;
}

// Renders the supplied neon fist PNGs. Size: 16px mobile / 18px desktop.
// Do not recolor with CSS — the PNGs already contain the neon glow.
export const PunchFist = ({ variant, className = "", alt = "" }: PunchFistProps) => {
  const src = variant === "green" ? greenFist.url : purpleFist.url;
  return (
    <img
      src={src}
      alt={alt}
      aria-hidden={alt ? undefined : true}
      className={`inline-block w-4 h-4 md:w-[18px] md:h-[18px] shrink-0 align-middle object-contain ${className}`}
    />
  );
};
